import { css } from "@emotion/react";
import { ButtonGroup, Icon, StatusDot } from "@madhive/kit-ui";

/**
 * Displays a legend for the status dots used in AgentMessage components.
 */
function AgentMessageStatusDotDescriptions() {
  return (
    <div
      className="kitPlus-AgentMessageStatusDotDescriptions"
      css={styles.base}
    >
      <ButtonGroup justifyContent="start" gap="8">
        <StatusDot intent="warning" />
        <Icon name="Arrow" direction="right" size="extra-small" />
        <span>Indicates the agent could not resolve the value.</span>
      </ButtonGroup>
      <ButtonGroup justifyContent="start" gap="8">
        <StatusDot intent="error" />
        <Icon name="Arrow" direction="right" size="extra-small" />
        <span>Indicates validation errors are present.</span>
      </ButtonGroup>
    </div>
  );
}

export const styles = {
  base: css`
    padding: 0 var(--spacing-4);
  `
};

AgentMessageStatusDotDescriptions.displayName =
  "AgentMessage.StatusDotDescriptions";

export default AgentMessageStatusDotDescriptions;
